import { z } from 'zod';
import { AppRole } from './enums.js';

export const CurrentUser = z.object({
  upn: z.string(),
  name: z.string(),
  roles: z.array(AppRole),
});
export type CurrentUser = z.infer<typeof CurrentUser>;

/**
 * Demo personas for mock auth (local dev and the static demo build). Picking a
 * persona is a role switch, not a sign-in: there is no password anywhere.
 * Names are fictional.
 */
export const DEMO_PERSONAS: readonly CurrentUser[] = [
  { upn: 'riley.chen@legends.example', name: 'Riley Chen', roles: ['Requester'] },
  { upn: 'morgan.patel@legends.example', name: 'Morgan Patel', roles: ['FinanceApprover'] },
  { upn: 'jordan.alvarez@legends.example', name: 'Jordan Alvarez', roles: ['D365Admin'] },
  { upn: 'casey.brooks@legends.example', name: 'Casey Brooks', roles: ['AppAdmin', 'D365Admin'] },
];

export function findPersona(upn: string): CurrentUser | undefined {
  const key = upn.trim().toLowerCase();
  return DEMO_PERSONAS.find((p) => p.upn === key);
}

/** Keep only role claim values the app knows about. */
export function parseRoles(claim: unknown): AppRole[] {
  if (!Array.isArray(claim)) return [];
  return claim.flatMap((r) => {
    const parsed = AppRole.safeParse(r);
    return parsed.success ? [parsed.data] : [];
  });
}

export function hasAnyRole(user: Pick<CurrentUser, 'roles'>, required: readonly AppRole[]): boolean {
  return required.length === 0 || required.some((r) => user.roles.includes(r));
}
